import React from 'react';
import {
  Avatar,
  Box,
  Tooltip,
  Typography,
  useTheme,
} from '@cherre-frontend/ui';
import { getNameInitials } from 'src/utils/getNameInitials';

type Props = {
  name: string;
  email: string;
};

const UserOption: React.FC<Props> = ({ name, email }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <Avatar
        sx={{
          width: '36px',
          height: '36px',
          fontSize: '16px',
          marginRight: '11px',
          fontWeight: 500,
          lineHeight: 1,
          backgroundColor: theme.palette.secondary.light,
        }}
      >
        {getNameInitials(name)}
      </Avatar>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='body1' sx={{ fontWeight: 700 }}>
          {name}
        </Typography>
        <Tooltip title={email}>
          <Typography
            variant='body2'
            sx={{
              color: theme.palette.grey[700],
              maxWidth: '270px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {email}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default UserOption;
